import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'negocio-page',
  templateUrl: './negocio-page.component.html',
  styleUrls: ['./negocio-page.component.scss']
})
export class NegocioPageComponent implements OnInit {

  public loader:any  = false; 
  public apelido = "negocio"; 
  public response = {
    data: "",
    status: null
  }
  public page:any     = {};
  public params:any   = {};
  public dataItem:any = {}
  public message      = "Carregando. Aguarde!";
  public itensB       = [{
    text: "Contato"
  }];
  public options = [];
  public photo   = null;
  public categorias:any = []; 
  public categoriaId:any = null;
  public changeCategoria:any = new EventEmitter();
  public isMobile:any = false;
  public token        = "wRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
  public dataToken    = null;
  public template = 1;
  public foto:any = null;
  public fotoData:any = null;
  public formTemplate = 1;
  
  constructor(
    private app: AppService,
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ){

    this.dataToken = this.route.params["_value"].token || null;  

    if(this.dataToken != null){

      if(this.dataToken != this.token){

        this.router.navigateByUrl("/");

      }else{

        this.template = 2;

      }

    }

  } 
  /***
   * 
   * Select Categoria
   * 
   */
  selectCategoria(item:any){

    this.categoriaId = item.id;
    this.changeCategoria.emit(this.categoriaId);

  }
  /**
   * 
   * Store
   * 
   */
  store(){

    try{

      this.loader = true;

      this.api.negocios().store(this.dataItem,this.fotoData).subscribe((response) => {

        this.loader = false;

        if(response.status == 1){

          this.initDataItem();
          this.formTemplate = 2;
          this.app.toTop();

        }else{

          let error   = this.api.formatError(response);
          this.app.info(error.message);

        }
        

      },(response:any) => {

        this.loader = false;
        let error   = this.api.formatError(response);

        this.app.info(error.message);

      });

    }catch(e:any){

      this.loader = false;
      this.app.info("Houve um erro: "+e.message);

    }


  }
  /**
   * 
   * Retorna os dados da página
   * 
   */
  getData(){

    try{

      this.message = "Enviando. Aguarde!";  
      this.loader  = true;

      this.api.conteudo().page(this.apelido).subscribe(response => {

        this.loader = false;   

        if(response.status == 1){
                
          if(typeof(response.data.page) != "undefined"){
            
            this.response = {  
              data: "",
              status: 1
            }

            this.page      = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params    = this.page.params != null ? JSON.parse(this.page.params) : {};

            this.categorias = response.data.categoria;

            this.app.setMetaDados(this.page.meta_title,this.page.meta_description); 

              
          }
      
      
        }else{
          this.response = {
            data: response.data,
            status: 500 
          }
        }
        this.app.toTop(); 

      },(response) => {

        this.loader = false;
        this.app.toTop(); 
      
      });

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * File
   * 
   */
  _file(event:any){

    const file:any = event.target.files[0];
    this.fotoData = file;
    var fReader = new FileReader();
    fReader.readAsDataURL(file);

    fReader.onloadend = function(event){
      var img:any = document.getElementById("foto");
      img.src = event.target.result;
    }

  }
  /***
   * 
   * Init data item
   * 
   */
  initDataItem(){

    this.dataItem = {
      nome: "",
      telefone: "",
      empresa_nome: "",
      empresa_telefone: "",
      empresa_atuacao: "",
      texto: "",
      empresa_servicos: "",
      link_instagram: "",
      link_facebook: "",
      link_site: "",
      empresa_endereco: "",
      observacao: ""
    }

  }
  /**
   * 
   * Init
   * 
   **/
  ngOnInit():void{
    if(this.template == 1){
      this.getData();
    }else{
      this.initDataItem();
    }
    this.isMobile = this.app.isMobile();
  }

}
